import { Reducer } from 'redux';
import { ISagaModule } from 'redux-dynamic-modules-saga';
import { connectRouter } from 'connected-react-router';

import { alertsReducer } from 'common/components/notifications/reducer';
import { rootAlertSaga } from 'common/components/notifications/sagas';
import { sessionReducer } from 'common/store/session/reducer';
import { rootSessionSaga } from 'common/store/session/sagas';
import { workspacesReducer } from 'common/store/workspaces/reducer';
import historyService from 'common/services/HistoryService';
import { fileUploadReducer } from 'common/store/fileUpload/reducer';

import actionReducer from 'common/util/reduxEffect/actionReducer';
import { rootWorkspacesSaga } from './workspaces/sagas';
import { RootState } from './rootReducer';
import { contextReducer } from './context/reducer';
import { assessmentReducer } from './assessment/reducer';
import { reloadReducer } from '../components/reload/reducer';
import { modalReducer, ModalState } from './modal/reducer';
import { optionsMenuReducer } from './optionsMenu/reducer';
import { rootContextSaga } from './context/sagas';
import { rootAssessmentSaga } from './assessment/sagas';
import { rootOptionsMenuSaga } from './optionsMenu/saga';
import { rootSyncActionsSaga } from './syncButton/sagas';
import { syncButtonReducer } from './syncButton/reducer';
import { validationWarningReducer } from './warning/reducer';
import { aiSupportedMarkingIntroReducer } from '../features/aiSupportedMarkingIntro/reducer';

export const getRootModule = (): ISagaModule<RootState> => ({
    id: 'root',
    reducerMap: {
        context: contextReducer,
        session: sessionReducer,
        workspaces: workspacesReducer,
        assessment: assessmentReducer,
        router: connectRouter(historyService.getHistory()),
        alerts: alertsReducer,
        reload: reloadReducer,
        fileUpload: fileUploadReducer,
        modal: modalReducer as Reducer<ModalState>,
        optionsMenu: optionsMenuReducer,
        syncButton: syncButtonReducer,
        action: actionReducer,
        warning: validationWarningReducer,
        aiSupportedMarkingIntro: aiSupportedMarkingIntroReducer,
    },
    sagas: [
        rootAssessmentSaga,
        rootSessionSaga,
        rootWorkspacesSaga,
        rootAlertSaga,
        rootContextSaga,
        rootOptionsMenuSaga,
        rootSyncActionsSaga,
    ],
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
});
